import PropTypes from 'prop-types'
import React from 'react'

const NotificationMessage = ({ message: { title, text } }) => {
  return (
    <div>
      {title && <h2 className='title'>{title}</h2>}
      <p>{text}</p>
    </div>
  )
}

NotificationMessage.propTypes = {
  message: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string.isRequired
  })
}

export default NotificationMessage
